import React, { useEffect, useState } from "react";
import CustomInput from "../../Common/CustomInput";
import CustomTextarea from "../../Common/CustomTextArea";
import api from "../../http";
import { toast } from "react-toastify";
import { ErrorHandlingMessage } from "../../Utils/ErrorHandlingMessage";
import FullPageLoader from "../../Components/FullPageLoader/FullPageLoader";
import Validator, { ValidationTypes as V_Type, } from "react-form-supervalidator";
import InsurancePlanSuperSearch from "Components/InsurancePlanSuperSearch/InsurancePlanSuperSearch";
import NumberConversion from "Utils/NumberConversion";
import FileAttachmentViewer from "Popups/FileAttachmentViewer/FileAttachmentViewer";
import CustomRadio from "Common/CustomRadio";
import PayWithCardInsurancePopup from "Popups/PayWithCardInsurancePopup/PayWithCardInsurancePopup";
import { MAX_FILE_SIZE_20MB, PAYMENT_METHODS } from "Common/Constants";
import CustomButtonNew from "Common/CustomButtonNew/CustomButtonNew";
import CustomDraggable from "Common/CustomDraggable/CustomDraggable";
import ReactPortal from "Components/ReactPortal/ReactPortal";
import { useSearchParams } from "react-router-dom";
import { Tooltip } from 'react-tooltip'
import CustomSelect from "Common/CustomSelect/CustomSelect";
import ConfirmationPopup from "Popups/ConfirmationPopup/ConfirmationPopup";
import CustomFileAttachment from "Common/CustomFileAttachment/CustomFileAttachment";
import { EXTENSION_NOT_ALLOWED, FILE_SIZE_MUST_BE_LESS_THAN_20MB } from "Common/ToastConstants";


const initialPaymentAttachmentModel = [
  // {
  //   addedBy: "",
  //   // "addedDate": "",
  //   updatedBy: "",
  //   updatedDate: "",
  //   inActive: false,
  //   inActiveReason: "",
  //   inActiveBy: "",
  //   inActiveDate: "",
  //   id: 0,
  //   paymentMainId: 0,
  //   paymentMain: "",
  //   fileName: "",
  //   url: "",
  //   fileBase64: "",
  // },
];
const allowedFileTypes = [
  "application/pdf",
  "image/jpeg",
  "image/jpg",
  "image/png",
  "text/plain",
  "835"
  // "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  // "application/vnd.ms-excel",
];

const getButtonLabel = (paymentModel, Id) => {
  if (paymentModel.paymentMethod === PAYMENT_METHODS.CHECK) {
    return Id ? "Update" : "Save";
  }
  if (paymentModel.paymentSource === "Terminal" && !Id) {
    return "Collect & Apply Payment";
  }
  return Id ? "Update" : "Save";
};

const AddPaymentPopup = ({ onClose, Id, disableDraggable }) => {
 
  const UNIQUE_ID = "AddPaymentPopup"
  const [paymentModel, setPaymentModel] = useState({
    practiceId: 0,
    addedBy: "",
    addedDate: "2023-06-26T10:59:20.212Z",
    updatedBy: "",
    updatedDate: "",
    paymentSource: "",
    receiptNumber: "",
    inActive: false,
    inActiveReason: "",
    inActiveBy: "",
    inActiveDate: "",
    id: 0,
    paymentType: "EOB",
    receivedDate: "",
    depositDate: "",
    patientId: 0,
    payerId: "",
    payerName: "",
    paidAmount: "",
    writeOffAmount: 0,
    paymentMethod: PAYMENT_METHODS.CHECK,
    paymentVia: "",
    stripeSettingsId: "",
    checkNumber: "",
    checkDate: "",
    ccTransactionID: "",
    ccTransactionDate: "",
    notes: "",
    isLocked: false,
    isPosted: false,
    postedBy: "",
    datePosted: "",
    isDuplicate: false,
    receiverId: 0,
    ediResponseDownloadedFileID: 0,
    status: "",
    payerAddress: "",
    payerCity: "",
    payerState: "st",
    payerZipCode: "",
    reF_2U_ID: "",
    payerContactPerson: "",
    payerContactNumber: "",
    markForAutoPosting: false,
    autoActionPerformed: false,
    paymentAttachment: initialPaymentAttachmentModel,
    visitPayments: null,
  });
  const [loading, setLoading] = useState(false);
  const [viewAttachment, setViewAttachment] = useState({
    status: false,
    Attachment: 0,
    fileExtension: ""
  });
  const [payWithCardPopup, setPayWithCardPopup] = useState(false)
  const [stripeAccounts, setStripeAccounts] = useState([]);
  const [deleteAttachment, setDeleteAttachment] = useState({
   id:null,
   status:false
  })
  const [publishKey, setPublishKey] = useState("");
  const [searchParams] = useSearchParams();
  const patientId = searchParams.get("patientId");

  const openViewAttachment = (item, itemIndex) => {
    setViewAttachment((prev) => ({
      ...prev,
      status: true,
      Attachment: item.fileBase64,
      fileExtension: item.fileName?.slice(item.fileName.lastIndexOf('.') + 1)
    }))
  }
  const closeViewAttachment = () => {
    setViewAttachment((prev) => ({
      ...prev,
      status: false,
      Attachment: "",
      fileExtension: ""
    }))
  }
  const [validationModel, setValidationModel] = useState({
    paymentMethod: null,
    checkDate: null,
    checkNumber: null,
    payerIdError: null,
    amountError: null,
    receivedDateError: null,
    PaymentSourceError: null,
    stripeAccountError: null,
    notesError: ""
  });

  const handleStripeAccount = (event) => {
    const selectedOption = event.target.selectedOptions[0];
    if (selectedOption) {
      const key = selectedOption.getAttribute("data-name1");
      setPaymentModel((prev) => ({
        ...prev,
        stripeSettingsId: event.target.value

      }))
      setPublishKey(key);
    }
    // const value = e.target.value
  };
  const setValidation = () => {
    let validationObj = {
      ...validationModel,
      payerIdError: Validator(paymentModel.payerId, [V_Type.required], ["Insurance Name is required"]),
      paymentMethod: Validator(paymentModel.paymentMethod, [V_Type.required], ["Payment Method is required"]),
      amountError: Validator(paymentModel.paidAmount, [V_Type.required], ["Amount is required"]),
      receivedDateError: Validator(paymentModel.receivedDate, [V_Type.required], ["Received Date  is required"]),
      ...(paymentModel.paymentMethod === "Virtual Credit Card" && {
        PaymentSourceError: Validator(paymentModel.paymentSource, [V_Type.required], ["Payment Source  is required"]
        ),
      }),

      ...(paymentModel.paymentMethod === PAYMENT_METHODS.CHECK && {
        checkNumber: Validator(
          paymentModel.checkNumber,
          [V_Type.required],
          ["Check Number is required"]
        )
      }),
      ...(paymentModel.paymentMethod === PAYMENT_METHODS.CHECK && {
        checkDate: Validator(
          paymentModel.checkDate,
          [V_Type.required],
          ["Check Date is required"]
        ),
      }),
      ...(paymentModel.paymentMethod !== PAYMENT_METHODS.CHECK && {
        stripeAccountError:
          paymentModel.paymentSource === "Terminal"
            ? Validator(paymentModel.stripeSettingsId, [V_Type.required], ["Stripe Account is required"])
            : "",
      }),

      ...(Id && { notesError: Validator(paymentModel.notes, [V_Type.required], ["Comments is required"]) }) // id there is update case then comments are neccassary
    };
    setValidationModel(validationObj);
    return Validator(validationObj, V_Type.NullCheck);
  };

  const onhandleChange = (e) => {
    let { name, value } = e.target;
    if (name === "paymentMethod") {
      setValidationModel((prev) => ({
        ...prev,
        paymentMethod: null,
        checkDate: null,
        checkNumber: null,
        payerIdError: null,
        amountError: null,
        receivedDateError: null,
        PaymentSourceError: null,
        stripeAccountError: null,
        notesError: ""
      }))
      setPaymentModel((prev) => ({
        ...prev,
        [name]: value,
        paymentSource: value === PAYMENT_METHODS.CHECK ? "" : "Terminal",
        stripeSettingsId: value === PAYMENT_METHODS.CHECK ? "" : stripeAccounts.length > 0 ? stripeAccounts[0].id : "",
      }));
      setPublishKey(stripeAccounts.length > 0 ? stripeAccounts[0].p_Key : "")
    } else if (name === "checkDate") {
      setPaymentModel((prev) => ({
        ...prev,
        [name]: value,
        ...(!Id && { depositDate: value, receivedDate: value }),// on update do not change Desposite and Recevied date on changing check date
      }));
    } else if (name === "paymentAttachment") {
      const selectedFile = e.target.files;
      for (const element of selectedFile) {
        let fileTypes = element.type || element.name.split(".")[1];
        if (element && allowedFileTypes.includes(fileTypes)) {
          if (MAX_FILE_SIZE_20MB >= element.size) {
            const reader = new FileReader();
            reader.onload = function (event) {
              setPaymentModel((prev) => ({
                ...prev,
                paymentAttachment: [
                  ...prev.paymentAttachment,
                  {
                    addedBy: "",
                    updatedBy: "",
                    updatedDate: "",
                    inActive: false,
                    inActiveReason: "",
                    inActiveBy: "",
                    inActiveDate: "",
                    id: 0,
                    paymentMainId: 0,
                    paymentMain: "",
                    fileName: element.name,
                    url: "",
                    fileBase64: event.target.result,
                  },
                ]
              }))

            };
            reader.readAsDataURL(element);
          } else {
            toast.warning(FILE_SIZE_MUST_BE_LESS_THAN_20MB)
          }
        } else {
          toast.warning(EXTENSION_NOT_ALLOWED)
        }
      }
    }
    else {
      setPaymentModel((prev) => ({
        ...prev,
        [name]: value,
      }));
    }
  };

  const handleSelectedData = (selectedObj) => {
    if (selectedObj) {
      setPaymentModel((prev) => ({
        ...prev,
        insurancePlanId: selectedObj.insurancePlanId,
        payerId: selectedObj.payerId,
        payerName: selectedObj.payerName,
      }));
    } else {
      setPaymentModel((prev) => ({
        ...prev,
        insurancePlanId: "",
        payerId: "",
        payerName: "",
      }));
    }
  };

  const handleSavePayment = async () => {
    if (!setValidation()) {
      if (paymentModel.paymentSource === "Terminal" && !Id) {
        setPayWithCardPopup(true)
      } else {
        try {
          setLoading(true);
          await api.post(
            `${process.env.REACT_APP_TC_PMS}/api/Payment/SavePayment`,
            {
              ...paymentModel,
              paymentAttachment: paymentModel.paymentAttachment[0]?.fileBase64
                ? paymentModel.paymentAttachment
                : null,
            }
          );
          toast.success(`${!Id ? "Saved" : "Updated"} Successfully`);
          setLoading(false);
          onClose(true);
        } catch (error) {
          setLoading(false);
          ErrorHandlingMessage(error);
        }

      }
    }
  };
  const handlePayWithCardCencel = () => {
    setPayWithCardPopup(false)
  }

  const handleClearAttachment = (item, itemIndex) => {
    const newAttc = paymentModel.paymentAttachment.filter((file) => file.fileName !== item.fileName)
    setPaymentModel(prevState => ({
      ...prevState,
      paymentAttachment: newAttc,
    }));
  };
  const handleDeleteAttachment = async (notes)=>{
    setLoading(true);
    try {
      const payload = {
        ids: [deleteAttachment.id],
        inActive: true,
        practiceId: 0,
        inActiveReason: notes
      };
      
      const response=  await api.post(
        `${process.env.REACT_APP_TC_PMS}/api/Payment/DeletePaymentMainAttachment`,
        payload
      );
      toast.success(response.data.responseMessage);
      setDeleteAttachment({ id: null, status: false })
      onClose(true);
    } catch (error) {
      ErrorHandlingMessage(error);
    } finally {
      setLoading(false);
    }
  }
  const openDeleteAttachment = (item,itemIndex)=>{
    if (item.id===0){
      handleClearAttachment(item, itemIndex)
    }else{
      setDeleteAttachment({ id: item.id ,status: true})
    }
  }
  const closeDeleteAttachment=()=>setDeleteAttachment({ id: null, status: false })


  useEffect(() => {
    if (Id) {
      (async () => {
        try {
          setLoading(true);
          const paymentResp = await api.get(`${process.env.REACT_APP_TC_PMS}/api/Payment/FindPaymentMain/${Id}`)
          setPaymentModel({
            ...paymentResp.data?.dataModel[0],
            paidAmount: NumberConversion(paymentResp.data?.dataModel[0].paidAmount, 'remove$'),
            paymentAttachment: paymentResp.data?.dataModel[0].paymentAttachment || [],
          });
        } catch (error) {
          ErrorHandlingMessage(error)
        } finally { setLoading(false) }
      })();
    }
  }, [Id]);

  useEffect(() => {
    if (paymentModel.paymentMethod === PAYMENT_METHODS.VIRTUAL_CREDIT_CARD) {
      (async () => {
        try {
          setLoading(true);
          const resp = await api.get(`${process.env.REACT_APP_TC_PMS}/api/StripeSettings/FindStripeSettings`)
          setStripeAccounts(resp.data.dataModel);
        } catch (error) {
          setStripeAccounts([]);
          ErrorHandlingMessage(error)
        } finally { setLoading(false) }
      })();
    }
  }, [paymentModel.paymentMethod]);

  const disabledPayerField = Id && paymentModel.payerId
  return (
    <ReactPortal wrapperId={UNIQUE_ID}>
      {deleteAttachment.status && <ConfirmationPopup
        buttonTitle="Delete"
        required
        onConfirm={(notes) => handleDeleteAttachment(notes)}
        heading="Add Reason"
        onCancel={closeDeleteAttachment}
        subHeading="Add reason to delete the attachment"
        reasonBox
      />}
      {payWithCardPopup && <PayWithCardInsurancePopup stripeSettingId={paymentModel.stripeSettingsId} paymentModel={paymentModel} P_Key={publishKey} onCloseinsurancePopup={onClose} ClosePaywithcard={handlePayWithCardCencel} />}
      {viewAttachment.status && <FileAttachmentViewer onClose={closeViewAttachment} viewAttachment={viewAttachment} />}
      {loading && <FullPageLoader allowFullScreen={true} />}
      <div
        data-te-modal-init
        className="fixed inset-0 z-10 flex items-center justify-center bg-gray-500 bg-opacity-75"
        id="exampleModalScrollable"
        tabIndex={-1}
        aria-labelledby="exampleModalScrollableLabel"
        aria-modal="true"
        data-te-open="true"
      >
        <CustomDraggable disableDraggable={disableDraggable} handle={`#${UNIQUE_ID}`}>
          <div
            data-te-modal-dialog-ref
            className="relative w-[900px] min-[576px]:mx-auto min-[576px]:mt-2 min-[576px]:max-w-[500px] min-[992px]:max-w-[800px] min-[1200px]:max-w-[1140px] flex flex-col overflow-hidden rounded-md bg-white shadow-lg"
          >
            {/* Header */}
            <div
              id={UNIQUE_ID}
              className="flex items-center justify-between p-5 text-2xl font-semibold border-b cursor-grab"
            >
              {!Id ? "Add" : "Update"} Insurance Payment
            </div>

            <div className="px-5 pt-5 overflow-y-auto max-h-[70vh]">
              <div className="grid grid-cols-12 gap-4">
                <div className="col-span-12 md:col-span-12">
                  <InsurancePlanSuperSearch disabled={disabledPayerField} label="Insurance Name" labelRequired searchValue={paymentModel.payerName} onChange={(value) => { setPaymentModel((prev) => ({ ...prev, payerName: value, })); }} handleSelectedData={handleSelectedData} />
                  {validationModel.payerIdError}
                </div>
                <div className="col-span-12 md:col-span-12">
                  <CustomRadio name="paymentMethod" disabled={Id} checked={paymentModel.paymentMethod}
                    options={[
                      { value: 'Check', label: 'Check' },
                      { value: 'Virtual Credit Card', label: 'Virtual Credit Card ' },
                    ]}
                    onChange={onhandleChange}
                  />
                  {validationModel.paymentMethod}
                </div>
                {paymentModel.paymentMethod === PAYMENT_METHODS.CHECK && <div className="col-span-12 md:col-span-4">
                  <CustomInput name="checkNumber" value={paymentModel.checkNumber} onChange={onhandleChange} label="Check Number" type="text" placeholder="Check Number" required={true} />
                  {validationModel.checkNumber}
                </div>}
                {paymentModel.paymentMethod === PAYMENT_METHODS.CHECK && <div className="col-span-12 md:col-span-4">
                  <CustomInput name="checkDate" value={paymentModel.checkDate?.split('T')[0]} onChange={onhandleChange} label="Check Date" type="date" placeholder="Name" required={true} />
                  {validationModel.checkDate}
                </div>}
                <div className="col-span-12 md:col-span-4">
                  <CustomInput name="paidAmount" value={paymentModel.paidAmount} disabled={Id && paymentModel.paymentSource === "Terminal"} isNumeric maxFloat={1} required isFloat onChange={onhandleChange} placeholder='0.00' SuffixIconClass="left-[.55rem] " prefixImg="/img/patientBalance.svg" label="Amount" type="text" />
                  {validationModel.amountError}
                </div>
                {paymentModel.paymentMethod === PAYMENT_METHODS.CHECK && <div className="col-span-12 md:col-span-4">
                  <CustomInput disabled={!!Id} name="depositDate" value={paymentModel.depositDate?.split('T')[0]} onChange={onhandleChange} label="Deposit Date" type="date" placeholder="Name" />
                </div>}
                <div className="col-span-12 md:col-span-4">
                  <CustomInput disabled={!!Id} name="receivedDate" value={paymentModel.receivedDate?.split('T')[0]} onChange={onhandleChange} required label="Received Date" type="date" placeholder="Name" />
                  {validationModel.receivedDateError}
                </div>
                {paymentModel.paymentMethod === PAYMENT_METHODS.VIRTUAL_CREDIT_CARD && <div className="col-span-12 md:col-span-4">
                  <CustomSelect disabled={Id} name="paymentSource" wrapperClass="!gap-0" labelClass="!mb-2 block" value={paymentModel.paymentSource} onChange={onhandleChange} required label="Payment Source" >
                    <option value="">Please Select</option>
                    <option value="Terminal">Stripe Terminal</option>
                    <option>External</option>
                  </CustomSelect>
                  {validationModel.PaymentSourceError}
                </div>}
                {paymentModel.paymentMethod !== PAYMENT_METHODS.CHECK && < div className="col-span-12 md:col-span-4">
                  {paymentModel.paymentSource === "Terminal" ? (
                    <div className="flex flex-col">
                      <CustomSelect label="Stripe Account" disabled={Id} name="stripeSettingId" required onChange={handleStripeAccount} value={paymentModel.stripeSettingsId}>
                        <option value="">Please Select</option>
                        {stripeAccounts?.map((account) => (
                          <option key={account.p_Key} value={account.id} data-name1={account.p_Key}>{account.stripeAccount}</option>
                        ))}
                      </CustomSelect>
                      {validationModel.stripeAccountError}
                    </div>
                  ) :
                    paymentModel.paymentSource === "External" && (
                      <div>
                        <label data-tooltip-id={"insurancePayment_tooltip"} data-tooltip-content="This relates to payment transaction ID, payment auth# or payment receipt#" className="inline-block mb-1.5 text-sm text-secondary ">  Receipt #</label>
                        <Tooltip id="insurancePayment_tooltip" style={{ zIndex: 12 }} />
                        <CustomInput value={paymentModel.receiptNumber} name="receiptNumber" onChange={onhandleChange} />
                      </div>
                    )}
                </div>}

                <div className="col-span-12 md:col-span-12 ">
                  <CustomTextarea maxWidth="100%" extraClass="w-full" required={!!Id} rows={3} name="notes" value={paymentModel.notes} onChange={onhandleChange} label="Comments" />
                  {validationModel.notesError}
                </div>
              </div>
              {paymentModel.paymentMethod === PAYMENT_METHODS.CHECK || Id ? <div className="col-span-12 my-4 md:col-span-4">
                <CustomFileAttachment
                  onFileChange={onhandleChange}
                  openViewAttachment={openViewAttachment}
                  name="paymentAttachment"
                  multiple
                  onDeleteFile={(item, itemIndex) => openDeleteAttachment(item, itemIndex)}
                  data={paymentModel.paymentAttachment}
                />
                <span className="text-sm"><span className="font-medium">Supported Files:</span> png, jpeg, pdf, txt</span>
              </div> : ""}
            </div>

            {/* Footer */}
            <div className="flex flex-wrap items-center justify-end gap-2 p-5">
              <CustomButtonNew variant="outline" label="Cancel" onClick={() => onClose(false)} />
              {!patientId && (
                <CustomButtonNew
                  label={getButtonLabel(paymentModel, Id)}
                  onClick={handleSavePayment}
                />
              )}
            </div>
          </div>
        </CustomDraggable>
      </div>
    </ReactPortal>
  );
};

export default AddPaymentPopup;
